import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[vrDragNDrop]'
})
export class DragNDropDirective {

  @Output() dropHandler: EventEmitter<any> = new EventEmitter<any>();

  public dragging: boolean;
  public loaded: boolean;
  public imageSrc: string;
  public invalidFlag: boolean;

  @HostListener('dragover') onDragOver() {
    return false
  }
  @HostListener('dragenter') handleDragEnter() {
    this.dragging = true;
  }
  @HostListener('dragleave') handleDragLeave() {
    this.dragging = false;
  }
  @HostListener('drop', ['$event']) handleDrop(e) {
    e.preventDefault();
    this.dragging = false;
    this.handleInputChange(e);
  }

  handleInputChange(e) {
    const file = e.dataTransfer ? e.dataTransfer.files[0] : 'null';
    const pattern = /image-*/;
    const reader = new FileReader();

    this.invalidFlag = false;

    if (!file.type.match(pattern)) {
      this.invalidFlag = true;
      alert('invalid format');
      return this.dropHandler.emit({ event: e, invalidFlag: this.invalidFlag});
    }

    this.loaded = false;
    reader.onload = this.handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  handleReaderLoaded(e) {
    const reader = e.target;
    this.imageSrc = reader.result;
    this.loaded = true;
    this.dropHandler.emit({ event: e, invalidFlag: this.invalidFlag});
  }

}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/utils/drag-n-drop.directive.ts